import React, {
  PropsWithChildren,
  useContext,
  useMemo,
  useReducer,
} from 'react';

import {
  ActionType,
  initialState,
  ProductDetailsReducer,
  productDetailsReducer,
} from '../reducer/productDetails.reducer';

interface ProductDetailsContextType extends ProductDetailsReducer {
  dispatch: React.Dispatch<ActionType>;
}

const ProductDetailsContext =
  React.createContext<ProductDetailsContextType>(null);

interface ProductDetailsProviderProps {
  deviceState: Partial<ProductDetailsReducer> | null;
}

export function ProductDetailsProvider({
  children,
  deviceState,
}: PropsWithChildren<ProductDetailsProviderProps>) {
  const [state, dispatch] = useReducer(productDetailsReducer, {
    ...initialState,
    ...deviceState,
  });

  const value = useMemo(() => ({ ...state, dispatch }), [state]);

  return (
    <ProductDetailsContext.Provider value={value}>
      {children}
    </ProductDetailsContext.Provider>
  );
}

export const useProductDetails = () => {
  const context = useContext(ProductDetailsContext);

  if (!context) {
    throw new Error(
      'useProductDetails should be used inside ProductDetailsProvider.',
    );
  }
  return context;
};
